import { cloneDeep } from "lodash";
import { IDeleteEntityAction } from "./deleteEntity";
import { TFormBuilderEntityLifecycleSnapshot } from "../actionHelpers/entityLifecycleSnapshot";
import { IFormBuilderForm } from "../../model/formBuilderForm";

export interface IAddEntityActionPayload {
  snapshot: TFormBuilderEntityLifecycleSnapshot;
}

export interface IAddEntityAction {
  type: "ADD_ENTITY";
  payload: IAddEntityActionPayload;
}

export function getAddEntityInverseAction(
  action: IAddEntityAction,
): IDeleteEntityAction {
  const { snapshot } = action.payload;

  return {
    type: "DELETE_ENTITY",
    payload: {
      snapshot: cloneDeep(snapshot),
    },
  };
}

function addEntity(form: IFormBuilderForm, snapshot: TFormBuilderEntityLifecycleSnapshot): IFormBuilderForm {
  if (snapshot.type === "row") {
    const { entity, entityIndex } = snapshot;

    return {
      ...form,
      children: [
        ...form.children.slice(0, entityIndex),
        entity,
        ...form.children.slice(entityIndex),
      ],
    };
  } else if (snapshot.type === "item") {
    const { origin, entity, entityIndex, parentRow, parentRowIndex } = snapshot;

    if (!form.children.some(row => row.key === parentRow.key)) {
      if (origin === "DELETE_ENTITY") {
        return {
          ...form,
          children: [
            ...form.children.slice(0, parentRowIndex),
            parentRow,
            ...form.children.slice(parentRowIndex),
          ],
        };
      } else {
        return form;
      }
    } else {
      return {
        ...form,
        children: form.children.map(row => {
          if (row.key === parentRow.key) {
            return {
              ...row,
              children: [
                ...row.children.slice(0, entityIndex),
                entity,
                ...row.children.slice(entityIndex),
              ],
            };
          } else {
            return row;
          }
        }),
      };
    }
  } else {
    return form;
  }
}

export function applyAddEntityChange(form: IFormBuilderForm, action: IAddEntityAction): IFormBuilderForm {
  const { snapshot } = action.payload;

  return addEntity(form, snapshot);
}